
import React from "react";
import "../../Styles/certified/iris.css";

export default function Iris() {
  return (
    <>
      <div className="iris-details-section">
        <div className="iris-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="iris-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="iris-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="iris-badge"
            />
            <div className="iris-company-names">
              <a href="https://www.iris.co.uk" target="_blank" rel="noopener noreferrer"><img src="https://iris.b-cdn.net/wp-content/uploads/2024/02/IRIS-logo-190x60-1.png" alt="Iris Logo" className="iris-company-logo" /></a>
              <h1 className="iris-full-name">
                IRIS KPO Resourcing India Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="iris-details-right">
            <img
              src="/assets/iris/iris1.jpg"
              alt="Iris Office"
              className="iris-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="iris-description">
          <h2>
            Why IRIS KPO Resourcing India Private Limited is a Outstanding Workplaces
          </h2>
          <p>
            We provide industry leading business critical software solutions and services to manage core business operations.
            We started 45 years ago with accountancy software and have evolved to be relied on by more than 100,000 customers across 135 countries in accountancy, education and business. 
            We help organisations to make better business decisions by developing integrated software solutions to minimise admin, make business processes more efficient and give more time to do what’s valued. 
            Accountants, schools, and teams in payroll, HR and finance use our software and services to solve some of the most important operational business problems. These include the need to remain compliant with the law, drastically reduce time spent on administration and reporting; and generating actionable data insights to make better business decisions.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="iris-info-cards">
          <div className="iris-info-card">
            <div className="iris-info-title">COMPANY SIZE</div>
            <div className="iris-info-value">850(India) Employees</div>
          </div>
          <div className="iris-info-card">
            <div className="iris-info-title">INDUSTRY</div>
            <div className="iris-info-value">Information Technology & Product Development</div>
          </div>
          <div className="iris-info-card">
            <div className="iris-info-title">CONNECT</div>
            <div className="iris-info-icons">
              <span className="iris-icon-round">
                <a href="https://www.iris.co.uk" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="iris-icon-round">
                <a href="https://uk.linkedin.com/company/iris-software-group" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="iris-icon-round">
                <a href="https://www.facebook.com/IRISSoftwareGroup" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="iris-icon-round">
                <a href="https://www.instagram.com/irissoftwaregroup" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="iris-icon-round">
                <a href="https://x.com/IRISSoftwareGrp" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="iris-info-card">
            <div className="iris-info-title">LOCATION (HQ)</div>
            <div className="iris-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="iris-recognition-section">
          <h2 className="iris-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="iris-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="iris-recognition-image"
            />
          </div>
          <div className="iris-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Iris Section */}
        <div className="iris-life-section">
          <h2 className="iris-life-title">
            Life at IRIS KPO Resourcing India Private Limited
          </h2>
          <div className="iris-life-gallery">
            <div className="iris-life-col">
              <img src="/assets/iris/collage1.jpg" alt="Office 1" className="iris-life-img" />
              <img src="/assets/iris/DSC09440.jpg" alt="Meeting 1" className="iris-life-img" />
            </div>
            <div className="iris-life-col iris-life-center">
              <img src="/assets/iris/main.jpg" alt="Main Office" className="iris-life-img iris-life-img-large" />
            </div>
            <div className="iris-life-col">
              <img src="/assets/iris/collage2.jpg" alt="Office 2" className="iris-life-img" />
              <img src="/assets/iris/DSC09471.jpg" alt="Meeting 2" className="iris-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}